import { SortOptions } from './CommonSortOptions';
import { CRASSSortOptions } from './CrassSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';


export const databaseWithCRASSSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'workbooks': CRASSSortOptions.downstreamWorkbookCount,
  'datasources': CRASSSortOptions.downstreamDataSourceCount,
  'connectionType': CRASSSortOptions.connectionType,
};